import { render, staticRenderFns } from "./occupationDetails.vue?vue&type=template&id=74640524&scoped=true&"
import script from "./occupationDetails.vue?vue&type=script&lang=js&"
export * from "./occupationDetails.vue?vue&type=script&lang=js&"
import style0 from "./occupationDetails.vue?vue&type=style&index=0&id=74640524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74640524",
  null
  
)

export default component.exports